<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div class="master-to-duplicates-container">
    <section class="pt-2 pb-2 border-bottom accordion" id="accordion">
        <div
            (click)="toggleCollapsed()"
            (keydown)="toggleCollapsed()"
            class="p-0 m-0 description"
            style="font-weight: 500; cursor: pointer"
        >
            <button windeActionIcon>
                <sui-svg-icon [icon]="isAreaCollapsed ? 'angle-right' : 'angle-down'" windeGrey />
            </button>
            Possible duplicates were detected during import, based on closeness between new and existing locations, or similarity of names.
            Click here for details and possible actions.
        </div>
        <small [ngClass]="{ show: !isAreaCollapsed }" aria-labelledby="heading" class="collapse" data-parent="#accordion" id="collapseArea">
            <dl class="mt-3">
                <dt><p>Possible status for the locations already in the topology:</p></dt>
                <dd class="left-margin-40">
                    <span class="badge origin">Existing location</span>
                    - means that the location already exists in the current topology.
                </dd>
                <dd class="left-margin-40">
                    <span class="badge frozen">Frozen</span>
                    - means that existing location has frozen links, therefore you can't modify its parameters.
                </dd>
                <br />
                <dt>
                    <p>
                        WiNDE recommends an action for the new location based on the distance between existing and new, or similarity
                        between names. Choose one of:
                    </p>
                </dt>
                <dd class="left-margin-40">
                    <span class="badge create-as-new">Import as new</span>
                    - this location will be imported as a new one, with a new name.
                </dd>
                <dd class="left-margin-40">
                    <span class="badge update-origin">Update existing</span>
                    - the parameters of the existing location will be updated with the information from the location in the import file.
                </dd>
                <dd class="left-margin-40">
                    <span class="badge potential-duplicate">Merge LOSes</span>
                    - the LOSes of the existing location will be merged with the LOSes of the duplicate from the import file
                </dd>
                <dd class="left-margin-40">
                    <span class="badge do-not-import">Don't import</span>
                    - the new location will not be imported.
                </dd>
            </dl>
        </small>
    </section>
    <div *ngFor="let topologyNode of topologyNodes | filter: searchText" class="master-to-duplicates-container-row">
        <winde-origin-node [origin]="topologyNode"></winde-origin-node>
        <div class="duplicates">
            <winde-duplicate-node
                *ngFor="let importedNode of getImportedNodes(topologyNode.getId()) | sortByDistance"
                [node]="importedNode"
            >
            </winde-duplicate-node>
        </div>
    </div>
    <ng-container *ngIf="duplicatedNewNodes?.length">
        <div *ngFor="let node of duplicatedNewNodes" class="master-to-duplicates-container-row">
            <div class="duplicates">
                <winde-duplicate-node
                    *ngFor="let importedNode of node | sortByDistance"
                    [node]="importedNode"
                    [relatedNodes]="getOriginsList(importedNode, node)"
                >
                </winde-duplicate-node>
            </div>
        </div>
    </ng-container>
</div>
